<template lang="pug">
el-pagination(
  v-bind="$attrs",
  background,
  layout="total, sizes, prev, pager, next, jumper",
  :page-sizes="sizes",
  v-on="$listeners",
  @current-change="currentChange",
  @size-change="sizeChange"
)
</template>
<script>
export default {
  name: "FPage",
  inheritAttrs: false,
  data() {
    return {
      sizes: [
        5, 10, 15, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000, 5000, 10000
      ]
    };
  },
  methods: {
    sizeChange(size) {
      this.$emit("page-change", 1, size);
    },
    currentChange(index) {
      this.$emit("page-change", index, this.$attrs.pageSize);
    }
  }
};
</script>
